module.exports = __webpack_public_path__ + "img/no_search.7c8857bf.png";